import * as React from 'react';
import KitHeader from "./Kit/KitHeader";
import Header from "./Standard/Header";
export var HeaderSelector = function () {
  if (window.layoutSettings.hash !== "") {
    return /*#__PURE__*/React.createElement(KitHeader, null);
  } else {
    return /*#__PURE__*/React.createElement(Header, null);
  }
};